module.exports = __webpack_public_path__ + "img/mobile-chart-no-data.d013f0cc.png";